import { PayNowDetail } from './../../models/pay-now-detail';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonFunctionService, UserMerchantData } from '../Common/common-function.service';
import { PayNowTransaction } from './../../models/pay-now-transaction';
import { catchError, map } from 'rxjs';

@Injectable()
export class EcomSolutionsService {
  token;
  headers: any;

  constructor(private http: HttpClient, private common: CommonFunctionService) {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }
  getPayNows(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PayNowDetail>(environment.getPayNows + '?merchantKeyId=' + data.merchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }
  getPayNow(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getPayNow + '?id=' + data.id + '&merchantKeyId=' + data.merchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }

  addPayNow(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.addPayNow, data, { headers: this.headers });
  }
  updatePayNow(data) {
    this.GetHeaderdetails();
    return this.http.put(environment.updatePayNow + '?id=' + data.Id, data, { headers: this.headers });
  }
  deletePayNow(data) {
    this.GetHeaderdetails();
    return this.http.put(environment.deletePayNow + '?id=' + data.Id, data, { headers: this.headers });
  }
  GetPayNowButtonCode(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PayNowDetail>(environment.ViewCodeUrl + '?id=' + data.id + '&merchantKeyId=' + data.merchantKeyId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });
  }
  transactiondetails(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PayNowTransaction>(environment.getPayNowtransactiondetails + '?PayNowKeys=' + data.PayNowKeys + '&MerchantKeyId=' + data.MerchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }
  transactionhistory(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PayNowDetail>(environment.transactionhistory + '?PayNowKeys=' + data.PayNowKeys + "&MerchantKeyId=" + MerchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }

  getPayNowsList(data, Email) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PayNowDetail>(environment.getPayNows + '?merchantKeyId=' + data + "&Email=" + Email + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }

  getPayNowsFlterList(data) {
    this.GetHeaderdetails();
    // const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    // return this.http.get<PayNowDetail>(environment.FilterManagePaybuttonUrl + '?merchantKeyId=' + data + "&fromdate=" +
    //   Fromdate1 + "&todate=" + todate1 + "&type=" + paymentType + "&label=" + Label + "&name=" +
    //   name + "&amount=" + Amount + "&symbol=" + symbol + "&LoggedinUserEmail=" + Email + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });
return this.http.post<any>(environment.FilterManagePaybuttonUrl,data,{headers:this.headers});
  }
  getFilterPayNowtransactiondetails(MerchantKeyId, Fromdate1, todate1, status, batchid, Amount, mobilenumber, amountcompare, PayNowKey, PaymentType) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PayNowTransaction>(environment.getFilterPayNowtransactiondetails + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1
      + "&Status=" + status + "&TransactionId=" + batchid + "&Amount=" + Amount + "&Mobilenumber=" + mobilenumber + "&AmountCheck=" + amountcompare + "&ViewId=" + PayNowKey + "&PaymentType=" + PaymentType + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });
  }

  GetuserRoleBasedPermissions(userId, appName) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get(environment.getUserRoleBasedPermissions + "?UserId=" + userId + "&AppName=" + appName+"&LoginUserId="+merchantdata.UserId+"&MerchantKeyId="+merchantdata.MerchantKeyId, { headers: this.headers })
  }

  GetHeaderdetails() {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));


  }
}
